import React from 'react';
import { Header, Footer } from '../../components';
import { Link } from 'react-router-dom';

function SignupCanceledPage() {
  return (
    <div className="signup-canceled-page">
      <Header />
      <main style={{ maxWidth: 720, margin: '0 auto', padding: '64px 24px' }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '12px' }}>Checkout Canceled</h1>
        <p style={{ fontSize: '1rem', lineHeight: 1.5, color: 'var(--text-secondary)', marginBottom: '24px' }}>
          Your subscription checkout was canceled. No charges were made. You can pick a different plan or retry when ready.
        </p>
        <Link to="/signup/plan" className="login-link" style={{ fontWeight: 600 }}>Choose a Plan</Link>
        <div style={{ marginTop: '40px', fontSize: '.8rem', color: 'var(--text-muted)' }}>
          Need help? <Link to="/contact" className="login-link">Contact support</Link>.
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default SignupCanceledPage;
